// @ts-check
/* istanbul ignore file */
import { DefinitionLevels, SettingValues } from '@linearb/linjs-common';
import { getAvailableMetrics } from 'common/services/metrics.service';
import { WhiteSection } from 'components/base/layout-components';
import useSettingsService from 'components/hooks/useSettingsService';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import GroupAllTeamsEmptyState from './GroupAllTeamsEmptyState/GroupAllTeamsEmptyState';
import GroupMetricsTable from './GroupMetricsTable/GroupMetricsTable';
import { GroupDashboardMetrics } from './GroupDashboardMetrics';
import {
  getIncludedMetrics,
  widgetsMetricsNamesInitialState
} from './groupDashboard.service';
import useGroupTeams from './hooks/useGroupTeams/useGroupTeams';
import { uiStateSelector } from 'state/selectors/ui-state';
import { useSelector } from 'react-redux';
import useLoadingTimerAlert from '../../projects/Forecasting/ProjectProgression/ProgressionOverTime/Header/useLoadingTimerAlert';
import { StyledLoadingAlertWrapper } from './GroupDashboard.style';
import LoadingAlert from 'components/base/empty-states/LoadingAlert';

const GroupDashboard = ({
  toggleModal,
  isSelectedTeamParent,
  gitScopeToggle
}) => {
  const history = useHistory();
  const uiState = useSelector(uiStateSelector);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const widgetsMetricsNamesInitialStateSettingValue =
    getSettingOrDefinitionValue({
      name: SettingValues.GROUP_DASHBOARD_METRICS_WIDGETS,
      definitionLevel: DefinitionLevels.TEAM,
      teamId: uiState?.selectedTeamId
    });

  const [isMetricsLoading, setIsMetricsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);

  const loadingTimerAlert = useLoadingTimerAlert(
    isMetricsLoading || isTableLoading
  );

  const [widgetsMetricsNames, setWidgetsMetricsNames] = useState(
    widgetsMetricsNamesInitialStateSettingValue ||
      widgetsMetricsNamesInitialState
  );

  useEffect(() => {
    if (uiState?.selectedTeamId) {
      const currentSelected = getSettingOrDefinitionValue({
        name: SettingValues.GROUP_DASHBOARD_METRICS_WIDGETS,
        definitionLevel: DefinitionLevels.TEAM,
        teamId: uiState?.selectedTeamId
      });
      setWidgetsMetricsNames(currentSelected);
    }
  }, [uiState?.selectedTeamId]);

  const [availableMetricsWidgets, setAvailableMetricsWidgets] = useState([]);
  const { selectedGroup, contributorsById } = useGroupTeams();

  useEffect(() => {
    getAvailableMetrics().then(metrics => {
      const data = metrics ? Object.values(metrics) : [];
      const availableMetricsByType = getIncludedMetrics(data);
      setAvailableMetricsWidgets(availableMetricsByType);
    });
  }, []);

  return (
    <>
      {!isSelectedTeamParent ? (
        <GroupAllTeamsEmptyState history={history} />
      ) : (
        <>
          <GroupDashboardMetrics
            toggleModal={toggleModal}
            widgetsMetricsNames={widgetsMetricsNames}
            availableMetricsWidgets={availableMetricsWidgets}
            setWidgetsMetricsNames={setWidgetsMetricsNames}
            gitScopeToggle={gitScopeToggle}
            setIsMetricsLoading={setIsMetricsLoading}
          />
          {loadingTimerAlert && (
            <StyledLoadingAlertWrapper>
              <LoadingAlert
                title={loadingTimerAlert.title}
                description={loadingTimerAlert.description}
              />
            </StyledLoadingAlertWrapper>
          )}

          <WhiteSection borderRadius='0.45rem' padding='2rem'>
            <GroupMetricsTable
              selectedGroup={selectedGroup}
              contributorsById={contributorsById}
              availableMetricsWidgets={availableMetricsWidgets}
              toggleModal={toggleModal}
              gitScopeToggle={gitScopeToggle}
              setIsTableLoading={setIsTableLoading}
            />
          </WhiteSection>
        </>
      )}
    </>
  );
};

export default GroupDashboard;
